import axios from '@/http/axios/index.js'


export default {
    getLogs(payload) {
        return axios.get('rps/logs', { params: payload }).then(res => res.data)
    }
}